import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { USER_LANGUAGES } from 'app/constants/enums/Language';
import { LocalizationService } from 'app/services/localization';
import Index, { IProps } from 'app/static/components/Index';
import { assetBaseURL } from 'app/config/client';

type Props = Pick<IProps, 'bundleScripts' | 'version' | 'serverRenderedContent' | 'lang'>;
export default function generateIndexFile({ bundleScripts, version, serverRenderedContent, lang }: Props) {
  const localizationService = new LocalizationService();
  const noscriptMessages = [...new Set(
    USER_LANGUAGES.map(({ id }) =>
      localizationService.t('noscript-message', {}, { locale: id }),
    ).toArray(),
  )];

  const content = ReactDOMServer.renderToStaticMarkup(
    <Index
      bundleScripts={bundleScripts}
      noscriptMessages={[...noscriptMessages]}
      assetBaseURL={assetBaseURL}
      version={version}
      serverRenderedContent={serverRenderedContent}
      lang={lang}
    />);

  return {
    filePath: 'index.html',
    content: `<!DOCTYPE html>\n${content}`,
  };
}
